var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',{class:(_vm.is_deleted ? 'archived-section' : ((_vm.is_full_disbursement || _vm.is_special_condition) ? '':'wait-full-disb-section'))},[_c('b-col',{attrs:{"cols":"12"}},[_c('CollectionSummary'),_c('CollectionDetail')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }